<template>
  <div>
    <canvas ref="qrCanvas"></canvas>
  </div>
</template>

<script>

import QRCode from 'qrcode';

export default {
  name: 'QrCode',
  props: {
    text: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 200
    }
  },
  mounted() {
    this.generateQrCode();
  },
  methods: {
    generateQrCode() {
      QRCode.toCanvas(this.$refs.qrCanvas, this.text, { width: this.size }, (err) => {
        if (err) {
          console.error('生成二维码失败：', err);
        }
      });
    }
  }
};
</script>
